import { CmStreamingFormat } from '@svta/cml-cta'

/**
 * Common Media Server Data Streaming Format
 *
 *
 * @enum
 *
 * @beta
 */
export const CmsdStreamingFormat = CmStreamingFormat as typeof CmStreamingFormat

/**
 * @beta
 */
export type CmsdStreamingFormat = CmStreamingFormat;
